"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSystemSettingView = instanceOfSystemSettingView;
exports.SystemSettingViewFromJSON = SystemSettingViewFromJSON;
exports.SystemSettingViewFromJSONTyped = SystemSettingViewFromJSONTyped;
exports.SystemSettingViewToJSON = SystemSettingViewToJSON;
exports.SystemSettingViewToJSONTyped = SystemSettingViewToJSONTyped;
/**
 * Check if a given object implements the SystemSettingView interface.
 */
function instanceOfSystemSettingView(value) {
    if (!('ssSys' in value) || value['ssSys'] === undefined)
        return false;
    if (!('ssPwRe' in value) || value['ssPwRe'] === undefined)
        return false;
    if (!('ssPwMinLength' in value) || value['ssPwMinLength'] === undefined)
        return false;
    if (!('ssPwMaxLength' in value) || value['ssPwMaxLength'] === undefined)
        return false;
    if (!('ssActivedDay' in value) || value['ssActivedDay'] === undefined)
        return false;
    if (!('ssPwStrong' in value) || value['ssPwStrong'] === undefined)
        return false;
    if (!('ssPwLike' in value) || value['ssPwLike'] === undefined)
        return false;
    if (!('ssPwErrorLimit' in value) || value['ssPwErrorLimit'] === undefined)
        return false;
    if (!('ssPwAction' in value) || value['ssPwAction'] === undefined)
        return false;
    if (!('ssPwLifetime' in value) || value['ssPwLifetime'] === undefined)
        return false;
    if (!('ssActivedShortestDay' in value) || value['ssActivedShortestDay'] === undefined)
        return false;
    return true;
}
function SystemSettingViewFromJSON(json) {
    return SystemSettingViewFromJSONTyped(json, false);
}
function SystemSettingViewFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'ssNo': json['ssNo'] == null ? undefined : json['ssNo'],
        'ssSys': json['ssSys'],
        'ssPwRe': json['ssPwRe'],
        'ssPwMinLength': json['ssPwMinLength'],
        'ssPwMaxLength': json['ssPwMaxLength'],
        'ssActivedDay': json['ssActivedDay'],
        'ssPwStrong': json['ssPwStrong'],
        'ssPwLike': json['ssPwLike'],
        'ssPwErrorLimit': json['ssPwErrorLimit'],
        'ssPwAction': json['ssPwAction'],
        'ssPwLifetime': json['ssPwLifetime'],
        'ssActivedShortestDay': json['ssActivedShortestDay'],
        'ssActived': json['ssActived'] == null ? undefined : json['ssActived'],
        'ssDisabledDay': json['ssDisabledDay'] == null ? undefined : json['ssDisabledDay'],
    };
}
function SystemSettingViewToJSON(json) {
    return SystemSettingViewToJSONTyped(json, false);
}
function SystemSettingViewToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'ssNo': value['ssNo'],
        'ssSys': value['ssSys'],
        'ssPwRe': value['ssPwRe'],
        'ssPwMinLength': value['ssPwMinLength'],
        'ssPwMaxLength': value['ssPwMaxLength'],
        'ssActivedDay': value['ssActivedDay'],
        'ssPwStrong': value['ssPwStrong'],
        'ssPwLike': value['ssPwLike'],
        'ssPwErrorLimit': value['ssPwErrorLimit'],
        'ssPwAction': value['ssPwAction'],
        'ssPwLifetime': value['ssPwLifetime'],
        'ssActivedShortestDay': value['ssActivedShortestDay'],
        'ssActived': value['ssActived'],
        'ssDisabledDay': value['ssDisabledDay'],
    };
}
